import { MenuItemTypeEnum } from "../../enums/menu-item-type.enum";
import { SupplyModel } from "./supply-model";

export class AddOrEditMenuItemModel {
  public id: string;
  public name: string;
  public price: number;
  public description: string;
  public companyId: string;
  public pictureURL: string;
  public languageId: string;
  public categoryId: string;
  public subcategoryId?: string;
  public companyMenuCategoryId: string;
  public menuItemTypeId: MenuItemTypeEnum;
  public supplies: Array<SupplyModel>;
  public taxRateId: string;
  public subvenueIds: Array<string> = new Array<string>();
}
